module.exports = __webpack_public_path__ + "img/yhq.cca3f0cb.png";